import { useContext } from "react";
import { TenantContext } from "./TenantContext";

export function useActiveTenant(): string | undefined {
  return useContext(TenantContext)?.tenantKey;
}